(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/pix-mix/components/pix-mix-container/assets/javascripts/pix-mix-container.js') >= 0) return;  svs.modules.push('/modules/pix-mix/components/pix-mix-container/assets/javascripts/pix-mix-container.js');

'use strict';

const {
  useState,
  useEffect
} = React;
const WidgetArea = svs.components.lbUtils.widgetArea.WidgetArea;
const {
  FULLTRAFF,
  MALTIPSET,
  STRYKTIPSET,
  T8,
  T8EXTRA,
  T8STRYK
} = svs.utils.products.productIds;
const {
  Hero
} = svs.components.marketplace.hero;
const {
  PixmixView,
  PixMixClosed,
  PixMixSkeleton
} = svs.pix_mix.components.pixmixView;
const {
  clx
} = svs.components.lbUtils;
const {
  CampaignFlerp
} = svs.components.lbUi.campaignFlerp;
const logger = new svs.core.log.Logger('svs.pix_mix.Pixmixen');
const {
  fetchDraws
} = svs.pix_mix.components.services;
const PixmixContainer = () => {
  const {
    image,
    title,
    subtitle,
    theme
  } = svs.pix_mix.data.hero;
  const [draws, setDraws] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [drawsErrored, setDrawsErrored] = useState(false);
  const fetchDrawsAndRefresh = () => {
    fetchDraws(response => {
      setDraws(response);
      setIsLoading(false);
    }, () => () => {
      setDrawsErrored(true);
      setIsLoading(false);
    });
  };
  useEffect(() => {
    fetchDrawsAndRefresh();
  }, []);

  const hasActiveDrawsForProducts = () => {
    const productsFromDraws = draws.map(draw => draw.productId);
    const topptipsetProductIds = [T8, T8EXTRA, T8STRYK];
    const fulltraffActive = productsFromDraws.includes(FULLTRAFF);
    const maltipsetActive = productsFromDraws.includes(MALTIPSET);
    const stryktipsetActive = productsFromDraws.includes(STRYKTIPSET);
    const topptipsetActive = topptipsetProductIds.filter(id => productsFromDraws.includes(id)).length > 0;
    logger.info("verifyActiveDrawsForProducts:\n      ".concat(fulltraffActive ? '✅' : '❌', " Fulltr\xE4ff\n      ").concat(maltipsetActive ? '✅' : '❌', " M\xE5ltipset\n      ").concat(stryktipsetActive ? '✅' : '❌', " Stryktipset\n      ").concat(topptipsetActive ? '✅' : '❌', " Topptipset\n    "));
    return fulltraffActive && maltipsetActive && stryktipsetActive && topptipsetActive;
  };
  const PixMixComponentWrapper = () => {
    if (isLoading) {
      return React.createElement(PixMixSkeleton, null);
    } else if (hasActiveDrawsForProducts()) {
      return React.createElement(PixmixView, {
        className: "pix-mix-content",
        draws: draws,
        refreshDraws: fetchDrawsAndRefresh
      });
    }
    return React.createElement(PixMixClosed, {
      className: "pix-mix-content"
    });
  };
  return React.createElement(React.Fragment, null, React.createElement(CampaignFlerp, null), (image || title) && !drawsErrored && React.createElement(Hero, {
    className: clx('pix-mix-hero', theme),
    horizontal: "center",
    image: image,
    vertical: "middle"
  }, React.createElement("div", {
    className: "pix-mix-hero-content"
  }, title && React.createElement("span", {
    className: "pix-mix-hero-title"
  }, title), subtitle && React.createElement("span", {
    className: "pix-mix-hero-subtitle"
  }, subtitle))), React.createElement(WidgetArea, {
    className: "pix-mix-widget-area pix-mix-before-widget-area",
    widgetArea: "pixmixBeforeWidgetArea"
  }), React.createElement("div", {
    className: "pix-mix-container"
  }, React.createElement(PixMixComponentWrapper, null)), React.createElement(WidgetArea, {
    className: "pix-mix-widget-area pix-mix-after-widget-area",
    widgetArea: "pixmixAfterWidgetArea"
  }));
};
setGlobal('svs.pix_mix.components.PixmixContainer', PixmixContainer);

 })(window);